import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { BetaTag } from "@design-system/BetaTag/BetaTag";
import { useAllowFeature } from "@hooks/useAllowFeature";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { useOverlays } from "contexts/OverlayContext";
import {
    StandardModal,
    StandardModalBody,
    StandardModalHeader,
} from "@design-system/Modal/Modal";
import { AccrualDocumentImporter } from "./AccrualDocumentImporter";
import { AccrualImporterContextProvider } from "./AccrualImporterContextProvider";
import { getAccrualDocumentImporterConfig } from "./accrualDocumentImporter.lib";

export const AccrualDocumentImporterModal: React.FC = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const { billInvoiceImporter } = useTypedFlags();
    const { hasAccess, isFetched } = useAllowFeature(
        PREMIUM_FEATURES.ACCRUAL_LEDGER,
    );
    const overlayInfo = getOverlayInfo("accrualDocumentImporter");

    if (
        !overlayInfo?.data ||
        !billInvoiceImporter ||
        !isFetched ||
        !hasAccess
    ) {
        return null;
    }

    const { mode } = overlayInfo.data;
    const config = getAccrualDocumentImporterConfig(mode);

    return (
        <StandardModal
            fullscreen
            onHide={closeOverlay}
            show={!overlayIsClosing}
        >
            <StandardModalHeader>
                <div>
                    {config.modalTitle}
                    <BetaTag />
                </div>
            </StandardModalHeader>
            <StandardModalBody>
                <AccrualImporterContextProvider
                    mode={mode}
                    readyToImportLabel="Ready to import"
                >
                    <AccrualDocumentImporter onHide={closeOverlay} />
                </AccrualImporterContextProvider>
            </StandardModalBody>
        </StandardModal>
    );
};
